import * as Sentry from '@sentry/svelte';

export function captureMessage(text: string, options?: any) {
    try {
        Sentry.captureMessage(text, options)
    } catch (e) {
        console.error(e)
    }
}
